import { IAppointment, IForm } from "lobbie";
import AppointmentListItem from "src/components/shared/appointments/AppointmentListItem";
import { IS_MOBILE_PHONE } from "src/constants";
import { isEmptyObject } from "../../../utils";
import NoForm from "./NoForm";
import PatientAppointmentForm from "./PatientAppointmentForm";

interface IProps {
    appointment: IAppointment;
}

const PatientAppointmentCard: React.FC<IProps> = ({ appointment }) => {
    const renderForms = (forms: IForm[]) => {
        return (
            <PatientAppointmentForm
                forms={forms}
                accountPublicUuid={appointment.accountPublicUuid}
            />
        );
    };

    const formsToRender = isEmptyObject(appointment.forms) ? (
        <NoForm />
    ) : (
        renderForms(appointment.forms)
    );

    const { location, practitioner } = appointment;
    if (!location || !practitioner) return null;

    if (IS_MOBILE_PHONE) {
        return (
            <div className="row my-2">
                <div className="col">
                    <AppointmentListItem appointment={appointment} />
                    <div className="mt-3">{formsToRender}</div>
                </div>
            </div>
        );
    }

    return (
        <div className="row my-5">
            <div className="col">
                <div className="row">
                    <div className="col mr-2">
                        <AppointmentListItem appointment={appointment} />
                    </div>
                    <div className="col ml-2">{formsToRender}</div>
                </div>
            </div>
        </div>
    );
};
export default PatientAppointmentCard;
